import { TipoProd } from '../../types/TipoProd';
import { api } from '../api';

interface IParams {
  docto: string;
  dtInicial: string | undefined;
  dtFinal: string | undefined;
  dtAntecipacao: string | undefined;
  tipoProd: string | undefined;
  pagina: number;
  limite: number;
  value?: number;
}

export interface GetAnticipationResult {
  idOrdemRepasse: string;
  dtMovimento: string;
  numOrdem: number;
  serie: string;
  parcela: number;
  dtPrevPgto: string;
  vlParcela: number;
  vlTxAdm: number;
  produtoId: number;
  produtoDescricao: string;
  bandeira: string;
  tipo: TipoProd;
  estabDocto: string;
  estabFantasia: string;
  vlAberto: number;
  permiteAntecipacao: 'N' | 'S';
  diasVencimento: number;
  vlTxAntSimulado: number;
  vlLocacao: number;
}

interface IParamsApplyAnticipationValue {
  docto: string;
  dtAntecipacao: string;
  emailSolicitante: string;
  itens: any[];
}

export async function getAnticipation(
  params: IParams
): Promise<GetAnticipationResult[]> {
  const { data } = await api.get('anticipations/antecipacaoListaOrdemRepasse', {
    params,
  });

  return data;
}

export const applyAnticipationValue = async (
  dataToApply: IParamsApplyAnticipationValue
) => {
  const result = await api.post('anticipations/antecipacao', dataToApply);

  return result;
};

export async function selectAnticipationValue(
  params: IParams,
  listEstablishmentToFilter: string[]
): Promise<GetAnticipationResult[]> {
  const { data } = await api.post(
    'anticipations/antecipacaoAplicarValor',
    { listEstablishmentToFilter },
    {
      params,
    }
  );

  return data;
}

export function useAntecipacao() {
  return {
    fetch: getAnticipation,
    selectAnticipationValue,
    applyAnticipationValue,
  };
}
